module.exports = __webpack_public_path__ + "assets/icons/my-location.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/my-location.png
// module id = ./src/styles/icons/my-location.png
// module chunks = 0